import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ email: "", password: "", name: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (mode === "login") await login(f.email, f.password);
      else await register(f.email, f.password, f.name);
      nav("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 md:py-24">
      <div className="eyebrow mb-4">{mode === "login" ? "WELCOME BACK" : "JOIN THE AUDIT"}</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold leading-none mb-8">
        {mode === "login" ? "LOG IN." : "SIGN UP FREE."}
      </h1>

      <form onSubmit={submit} className="space-y-4">
        {mode === "register" && (
          <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Name" data-testid="auth-name"
            className="w-full bg-transparent border hairline px-4 py-4 font-label text-sm outline-none focus:border-[#E63946]" />
        )}
        <input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="you@email.com" data-testid="auth-email"
          className="w-full bg-transparent border hairline px-4 py-4 font-label text-sm outline-none focus:border-[#E63946]" />
        <input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="Password" data-testid="auth-password"
          className="w-full bg-transparent border hairline px-4 py-4 font-label text-sm outline-none focus:border-[#E63946]" />
        {error && <p data-testid="auth-error" className="font-label text-xs text-[#E63946]">{error}</p>}
        <button type="submit" disabled={loading} data-testid="auth-submit"
          className="w-full font-label text-xs tracking-widest bg-[#E63946] text-white px-6 py-4 hover:bg-[#c62d39] transition-colors disabled:opacity-50">
          {loading ? "…" : mode === "login" ? "LOG IN →" : "CREATE ACCOUNT →"}
        </button>
      </form>

      <button onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }} data-testid="auth-toggle"
        className="mt-6 font-label text-xs tracking-widest text-stone-400 link-hover">
        {mode === "login" ? "NEW HERE? SIGN UP FREE →" : "ALREADY HAVE AN ACCOUNT? LOG IN →"}
      </button>
      <p className="mt-8 font-label text-[10px] tracking-widest text-stone-600">
        THE BASIC AUDIT NEVER NEEDS AN ACCOUNT. <Link to="/find" className="text-[#E63946]">JUST START →</Link>
      </p>
    </div>
  );
}
